import PopupShell from "@/components/popup-shell";
import styles from "@/components/privileges-popup.module.css";
import { globals } from "@/globals";
import * as signals from "@/signals";
import { closePopup } from "@/utils";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { JSX, useState } from "react";

interface PrivilegesPopupProps {
	isOpen: boolean;
}

function PrivilegesPopup({ isOpen }: PrivilegesPopupProps): JSX.Element {
	const [isClosing, setIsClosing] = useState<boolean>(false);

	const { appName, explanation, privileges } =
		signals.currentPrivilegesInfo.value;

	const closePrivilegesPopup = (): void => {
		setIsClosing(true);
		window.setTimeout(() => {
			closePopup("privileges");
			setIsClosing(false);
		}, globals.ANIMATION_WAIT_TIME);
	};

	const privilegesElem = privileges?.map((item) => {
		return (
			<div
				className={styles["privilege-item"]}
				key={item}
			>
				<FontAwesomeIcon
					icon={faCheck}
					fixedWidth
				/>
				{item}
			</div>
		);
	});

	return (
		<PopupShell
			isClosing={isClosing}
			isOpen={isOpen}
			onClose={closePrivilegesPopup}
		>
			<h1 className="popup-title">
				{appName && t(appName)}
				{t("premiumBenefits")}
			</h1>
			<div className="popup-content">
				{privilegesElem}
				<div
					className={styles["explanation"]}
					dangerouslySetInnerHTML={{
						__html: explanation || "",
					}}
				></div>
			</div>
		</PopupShell>
	);
}

export default PrivilegesPopup;
